module.exports = __webpack_public_path__ + "assets/retina_PtSymmetryDetailed.768ff4dab8cd6960ab66e9ce6d877cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_PtSymmetryDetailed.png
// module id = 706
// module chunks = 0